<template>
  <div>
    <Tables ref="tableGrid" class="col-mdEW-12 tabela"
            :columns="['Usuário',
              'Data',
              $lang.PCI.Layouts.DataTable.Description]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            :showPaging="false"
            :showHeader="false"
            :th_class="this.th_class"
            :showTipFooter="this.showTipFooter">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" classCss="text-left" :value="obj.nomeContaAcao" />
        <TableColumn :IsText="true" classCss="text-left" :value="obj.dataAcaoFormatada" />
        <TableColumn :IsText="true" classCss="text-left" :value="obj.descricao" />
      </tr>
    </Tables>
  </div>
</template>
<script>

import Tables from '@/components/forms/Tables'
import TableColumn from '@/components/forms/TableColumn'

export default {
  name: 'Tab',
  components: {
    Tables,
    TableColumn
  },
  props: {
    objList: [],
    showTipFooter: {
      type: Boolean,
      required: false,
      default: true
    },
    th_class: {
      type: String,
      required: false,
      default: 'text-center'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/SimpleTableList.vue